"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { useClientAuth } from "@/app/providers/client-auth";
import PageLoaderOverlay from "@/components/page-loader-overlay";

export function PublicOnlyGate({
  children,
  redirectTo = "/",
  loadingFallback,
}: {
  children: React.ReactNode;
  redirectTo?: string;
  loadingFallback?: React.ReactNode;
}) {
  const router = useRouter();
  const { status } = useClientAuth();

  React.useEffect(() => {
    if (status === "authenticated") {
      router.replace(redirectTo);
    }
  }, [redirectTo, router, status]);

  if (status === "loading" || status === "authenticated") {
    return <>{loadingFallback ?? <PageLoaderOverlay message="Loading..." opacity="dark" />}</>;
  }

  if (status === "error") {
    return <div className="p-4 text-sm text-red-500">Failed to load auth state.</div>;
  }

  return <>{children}</>;
}
